import conditionTypes from './condition-types';
import classes from './classes';

export function getRootElAttributes(options) {

  const conditionType = options.conditionType || conditionTypes.AND;

  const attributes = {};

  if (conditionType === conditionTypes.OR) {
    attributes.class = classes.OR;
  }

  return attributes;

}